module.exports = __webpack_public_path__ + "static/media/nophotos.97b10270.svg";